import React from "react";
import * as styles from "./rules-editor-connector.module.scss";

/**
 * A connector line between major cards in the rules editor
 */
export default function RulesEditorConnector() {
	return <div className={styles.connector} />;
}
